export default function findOptionIndex(item, options) {
  return item
    ? options.findIndex((optionItem) => optionItem.value === item.value)
    : null;
}
